import InputQuestion from './InputQuestion';

export default InputQuestion;
